module.exports = __webpack_public_path__ + "static/media/zusammen-zukunft-gestalten.2d74f721.jpg";